import { buildSearchParams } from '@/helpers/build-search-params'
import { getProductClient } from '@/http/products-client'
import type {
  ProductsSearchQuery,
  ProductsSearchResult,
} from '@/http/zamply/products/search-products-schema'
import { bff_client } from '@/lib/apiClient'
import type { CourseType } from '@/types/course-type'

/**
 * Resposta do BFF `GET /api/products`. O contrato de rede é
 * `V2ProductSearchResponse` (kubb), mas o DTO da OpenAPI é mais estreito que o
 * payload real (sem `workloads`, `areas`, `categories`, `is_new`...), que é o
 * que os cards consomem via `CourseType`.
 */
export type ProductsCatalogResponse = Omit<ProductsSearchResult, 'data'> & {
  data: CourseType[]
}

export function fetchProductsCatalog(
  query: ProductsSearchQuery,
  signal?: AbortSignal
): Promise<ProductsCatalogResponse> {
  return bff_client
    .get('products', { searchParams: buildSearchParams(query), signal })
    .json<ProductsCatalogResponse>()
}

export function fetchProduct(reference: string): Promise<CourseType> {
  return getProductClient(reference)
}
